var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"centerRight",attrs:{"src":_vm.getTrialProbe}}),_c('img',{staticClass:"center",attrs:{"src":require("../assets/optimal_fixation.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }